// extracted by mini-css-extract-plugin
module.exports = {"root":"ScreenTabsArea_root__VJgCG"};